<div class="login-form">
  <h2 class="login-form-title">Login</h2>

  <form #heroForm="ngForm">
    <div class="form-field">
      <label for="bookingcode">Booking #</label>
      <input
        id="bookingcode"
        class="login-input"
        type="text"
        [(ngModel)]="logincredentials.bookingcode"
        name="bookingcode"
        #bookingcode="ngModel"
        required
      />
    </div>

    <div class="form-field">
      <label for="lastname">Last Name</label>
      <input
        id="lastname"
        class="login-input"
        type="text"
        [(ngModel)]="logincredentials.lastname"
        name="lastname"
        #lastname="ngModel"
        required
      />
    </div>
  </form>

  <div class="errormessage">{{ loginmessage }}</div>

  <div class="buttonarea">
    <button
      type="button"
      (click)="login()"
      class="btn btn-primary btn-lg login-submit-btn"
      [disabled]="!heroForm.valid"
    >
      LOG IN
    </button>
  </div>
</div>
